<template>
    <modal ref="modal" class="fade" :needFooter="true" style="z-index: 10000">
        <template v-slot:header>
            <div class="me-3">
                <span class="fw-bolder cursor-pointer h3" @click="$refs.modal.close()" data-bs-dismiss="modal"
                      aria-label="Close">
                    <i class="fal fa-times text-primary"></i>
                </span>
            </div>
            <div class="w-100 pe-3 text-truncate">
                <span class="fw-bolder h4">{{ title }}</span>
            </div>
        </template>
        <div v-bind:class="class">
            <div v-if="icon" v-html="icon" class="icon"></div>
            <div class="message" v-html="message"></div>
        </div>
        <template v-slot:footer>
            <div class="flex-grow-1">
                <button v-if="cancelBtn" @click="_cancel" type="button"
                        class="btn btn-lg btn-outline-secondary rounded-pill"
                        data-bs-dismiss="modal">{{ cancelBtn }}
                </button>
            </div>
            <div>
                <button v-if="okBtn" @click="_confirm" type="button"
                        class="btn btn-lg btn-outline-primary rounded-pill">
                    {{ okBtn }}
                </button>
            </div>
        </template>

    </modal>
</template>

<script>
export default {
    name: "dialog-modal",
    data() {
        return {
            title: '',
            message: undefined, // Main text content
            okBtn: undefined, // Text for confirm button; leave it empty because we don't know what we're using it for
            cancelBtn: undefined, // text for cancel button
            resolvePromise: undefined,
            rejectPromise: undefined,
            icon: undefined,
            class: 'text-center',
        }
    },
    mounted() {
        console.log('mounted')
        emitter.on('notify', (data) => {
            console.log('modal', data)
            this.notification = data;
            this.show({
                title: data.title || this.$t('dialog.notification.title'),
                icon: data.icon || undefined,
                message: data.message,
                okBtn: this.$t('app.close'),
            });
            if (data.path != undefined) {
                location.href = data.path;
                if (data.reload != undefined) {
                    location.href = data.path;
                } else {
                    this.$router.push(data.path);
                }
            }
        })
    },
    beforeUnmount() {
        emitter.off('notify');
    },
    methods: {
        show(opts = {}) {
            this.title = opts.title;
            this.message = opts.message;
            if (opts.okBtn) {
                this.okBtn = opts.okBtn;
            } else {
                this.okBtn = false;
            }
            if (opts.icon) {
                this.icon = opts.icon;
            } else {
                this.icon = undefined;
            }
            if (opts.class) {
                this.class = opts.class;
            } else {
                this.class = 'text-center';
            }
            if (opts.cancelBtn) {
                this.cancelBtn = opts.cancelBtn;
            } else {
                this.cancelBtn = false;
            }
            this.$refs.modal.open()
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
                this.rejectPromise = reject;
            })
        },
        _confirm() {
            this.$refs.modal.close();
            this.resolvePromise(true);
        },

        _cancel() {
            this.$refs.modal.close();
            this.resolvePromise(false);
        },

    }
}
</script>

<style scoped>
.message {
    font-size: 18px;
}


.btn {
    min-width: 100px;
}
</style>
